import { Copyright } from "../components";

function Home() {
  return (
    <>
      <header className="App-header">
        <p>
          Be <code>onTime</code> 🐡 !
        </p>
      </header>
      <Copyright />
    </>
  );
}

export default Home;
